import React from 'react';
import { Reveal } from './Reveal';
const contents = [['📚', '5 Elementary Volumes', 'Volumes 1–5, a full year fully planned'], ['🏛️', '5 Secondary Volumes', 'Grades 1–5 with clear progression'], ['🖍️', 'Step-by-Step Activities', 'Ready to print and use'], ['📊', 'Assessments & Rubrics', 'Ready-made tools for every level'], ['🖌️', 'Artistic Techniques', 'Materials, process, and examples'], ['🎨', 'Integrated Art History', 'Movements and artists by level']];
export function KitContentsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-299">
      <Reveal className="mx-auto max-w-5xl" data-id="element-300">
        <h2 className="mb-12 text-center text-3xl font-black md:text-4xl" data-id="element-301">
          📦 What&apos;s Inside the Art Ready Pack?
        </h2>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-302">
          {contents.map(([icon, title, description]) => <article key={title} className="rounded-2xl border border-brand-dark bg-brand-dark p-7 text-center" data-id="element-303">
              <span className="text-3xl" aria-hidden="true" data-id="element-304">
                {icon}
              </span>
              <h3 className="mt-5 text-xl font-bold" data-id="element-305">{title}</h3>
              <p className="mt-2 text-sm text-brand-gray" data-id="element-306">{description}</p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}